module.exports = __webpack_public_path__ + "static/img/11.060e3b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/sp/11.png
// module id = 8hQl
// module chunks = 0